import BASIC_CONSTANT from 'constants/basic.constants.js/basic.constants.js';
import React from 'react';
import Owner from '../../assets/img/channel-icon/owner';
import Ghost from '../../assets/img/channel-icon/ghost';
import Manager from '../../assets/img/channel-icon/manager';
import Router from 'next/router';
import URL_CONSTANT from '../../constants/url.constants.js';
import ChannelClass from 'classes/ChannelClass';
import PropTypes from 'prop-types';
import { withTranslation } from 'utils/with-i18next';

const Channel = ({ listData, type, setId, t }) => {
  const channel = new ChannelClass();
  const token = localStorage.getItem(BASIC_CONSTANT.USER_TOKEN_KEY);

  const inviteHandle = async () => {
    if (listData.ghostChannel) {
      const answer = confirm(
        "이 채널은 ‘고스트 채널'로 멤버 초대 및 플레이리스트 추가 / 삭제 등의 기능이 제한됩니다. 그래도 가입하시겠습니까?"
      );
      if (answer) {
        const result = await channel.postJoinChannel(token, listData.id);
        if (result.code == 200) {
          let obj = { type: 'invite', id: listData.id };
          setId(obj);
        }
      }
    } else {
      const result = await channel.postJoinChannel(token, listData.id);
      if (result.code == 200) {
        let obj = { type: 'invite', id: listData.id };
        setId(obj);
      }
    }
  };

  const moveChannelDetail = () => {
    if (type !== 'invited') Router.push(URL_CONSTANT.player.url + '?channelId=' + listData.id);
  };

  const rejectHandle = async () => {
    const result = await channel.rejectChannel(token, listData.id);
    if (result.code === 200) {
      let obj = { type: 'reject', id: listData.id };
      setId(obj);
    }
  };

  return (
    <div className="group">
      <div
        onClick={() => moveChannelDetail()}
        className="relative aspect-square rounded-xl overflow-hidden cursor-pointer mb-3"
      >
        <div
          className="absolute inset-0 bg-cover bg-center transition-transform duration-300 group-hover:scale-105"
          style={{ backgroundImage: `url(${listData.channelImageUrl})` }}
        />
        <div className="absolute top-3 left-3">
          {listData.ghostChannel ? (
            <Ghost />
          ) : listData.myRole === 'OWNER' ? (
            <Owner />
          ) : listData.myRole === 'USER' ? null : (
            <Manager />
          )}
        </div>
      </div>
      <div>
        <p
          onClick={() => moveChannelDetail()}
          className="font-semibold text-white cursor-pointer hover:text-primary transition-colors"
        >
          {listData.channelName}
        </p>
        <p className="text-sm text-gray-400">
          {listData.ghostChannel
            ? '고스트'
            : listData.ownerNickname === listData.ownerEmail
            ? listData.ownerEmail
            : listData.ownerNickname}
          {' ∙ '}
          {listData.itemCount}
          {t('songs')}
        </p>
        {type === 'invited' && (
          <div className="flex gap-2 mt-3">
            <button
              id="invite-acceptBtn"
              onClick={inviteHandle}
              className="flex-1 py-2 px-4 bg-primary text-black text-sm font-semibold rounded-lg hover:bg-primary/90 transition-colors cursor-pointer"
            >
              {t('accept')}
            </button>
            <button
              id="invite-rejectBtn"
              onClick={rejectHandle}
              className="flex-1 py-2 px-4 bg-gray-700 text-white text-sm font-semibold rounded-lg hover:bg-gray-600 transition-colors cursor-pointer"
            >
              {t('refuse')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

Channel.propTypes = {
  t: PropTypes.func,
};

export default withTranslation('myChannel')(Channel);
